module.exports = __webpack_public_path__ + "img/Q02a.41531246.png";